import React from 'react';
import { ContentTemplate, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import PaymentLinkError from '../../components/PaymentLinkError';

const UniqueLinkExpired = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('components->>PaymentLinkError.Link has expired!')} />

      <ContentTemplate>
        <PaymentLinkError
          typographyMessage={t('components->>PaymentLinkError.Sorry, this link has expired.')}
          buttonMessage={t('components->>PaymentLinkError.Back to Home')}
        />
      </ContentTemplate>
    </>
  );
};

export default UniqueLinkExpired;
